import { render } from "./PromotionDetail.vue?vue&type=template&id=49bae83c&scoped=true"
import script from "./PromotionDetail.vue?vue&type=script&lang=js"
export * from "./PromotionDetail.vue?vue&type=script&lang=js"

import "./PromotionDetail.vue?vue&type=style&index=0&id=49bae83c&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49bae83c"]])

export default __exports__